import { Constants } from './../../utils/constants';
import { AppUtils } from './../../utils/app.utils';
import { Component, Input } from '@angular/core';
import { BovBmfModel } from '@dto/custody-model-bov-bmf';

@Component({
  selector: 'app-billet-position',
  templateUrl: './billet-position.component.html'
})
export class BilletPositionComponent {

  @Input() dense = false;
  @Input() set position(value: any) {
    this.updatePositionQuote(value);
  }
  listPosition: BovBmfModel = new BovBmfModel();

  get positionNetDayClass() {
    const netDayNumber = Number(this.listPosition.netDay);
    return netDayNumber > 0 ? 'high' : netDayNumber < 0 ? 'low' : '';
  }

  updatePositionQuote(position) {
    if (!position) {
      return;
    }
    if (position.marketCode === Constants.MARKET_BMF || position.marketCode === Constants.MARKET_BMF2) {
      this.listPosition.averagePricePos = position.averagePricePos ? AppUtils.numberToFormattedNumber(Number(position.averagePricePos), 2) : '-';
      this.listPosition.openProfitLoss = position.openProfitLoss ? AppUtils.numberToFormattedNumber(Number(position.openProfitLoss)) : '-';
      this.listPosition.closedProfitLoss = position.closedProfitLoss ? AppUtils.numberToFormattedNumber(Number(position.closedProfitLoss)) : '-';
      this.listPosition.openProfitLossColor = (this.listPosition.openProfitLoss && this.listPosition.openProfitLoss != '-')
        ? Number(this.listPosition.openProfitLoss.replace('.', '').replace(',', '.')) : 0;
      this.listPosition.closedProfitLossColor = (this.listPosition.closedProfitLoss && this.listPosition.closedProfitLoss != '-')
        ? Number(this.listPosition.closedProfitLoss.replace('.', '').replace(',', '.')) : 0;
    } else {
      this.listPosition.averagePricePos = position.averagePricePos ? position.averagePricePos : '-';
      this.listPosition.openProfitLoss = position.openProfitLoss ? position.openProfitLoss : '-';
      this.listPosition.closedProfitLoss = position.closedProfitLoss ? position.closedProfitLoss : '-';
      this.listPosition.openProfitLossColor = (this.listPosition.openProfitLoss && this.listPosition.openProfitLoss != '-')
        ? Number(this.listPosition.openProfitLoss.replace('.', '').replace(',', '.')) : 0;
      this.listPosition.closedProfitLossColor = (this.listPosition.closedProfitLoss && this.listPosition.closedProfitLoss != '-')
        ? Number(this.listPosition.closedProfitLoss.replace('.', '').replace(',', '.')) : 0;
    }
    this.listPosition.netDay = position.netDay ? Number(position.netDay).toFixed(0) : '-';
  }

}
